var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { TableLayout } from "@core/plugin/tc/component/table/types";
import { Component, Prop, Watch } from 'vue-property-decorator';
var TableProperties = /** @class */ (function (_super) {
    __extends(TableProperties, _super);
    function TableProperties() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layout = TableLayout.LAYOUT_RESPONSIVE;
        return _this;
    }
    Object.defineProperty(TableProperties.prototype, "prefix", {
        get: function () { return "".concat(this.id, "_"); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableProperties.prototype, "topAnchorName", {
        get: function () { return "tc-table-".concat(this.id, "-top"); },
        enumerable: false,
        configurable: true
    });
    TableProperties.prototype.getObjectPrimaryKeys = function (objects) {
        if (!objects || objects.length == 0) {
            return [];
        }
        return objects.map(function (object) { return object['_pk_']; });
    };
    TableProperties.prototype.data = function () {
        return {
            fields: this.initialFields,
            pagination: this.initialPagination,
            objects: this.initialObjects,
            objectPrimaryKeys: this.getObjectPrimaryKeys(this.initialObjects),
            filters: this.initialFilters,
            layout: this.initialLayout,
            settings: this.initialSettings,
        };
    };
    TableProperties.prototype.mounted = function () {
        this.onObjectsChanged();
    };
    TableProperties.prototype.onObjectsChanged = function () {
        this.objectPrimaryKeys = this.getObjectPrimaryKeys(this.objects);
    };
    __decorate([
        Prop({ type: String })
    ], TableProperties.prototype, "id", void 0);
    __decorate([
        Prop({ type: Object })
    ], TableProperties.prototype, "meta", void 0);
    __decorate([
        Prop({ type: Array })
    ], TableProperties.prototype, "initialFields", void 0);
    __decorate([
        Prop({ type: Array })
    ], TableProperties.prototype, "initialObjects", void 0);
    __decorate([
        Prop({ type: Object })
    ], TableProperties.prototype, "initialPagination", void 0);
    __decorate([
        Prop({ type: Array })
    ], TableProperties.prototype, "initialFilters", void 0);
    __decorate([
        Prop({ type: Array })
    ], TableProperties.prototype, "initialSorts", void 0);
    __decorate([
        Prop({ type: String })
    ], TableProperties.prototype, "initialLayout", void 0);
    __decorate([
        Prop({ type: Object })
    ], TableProperties.prototype, "initialSettings", void 0);
    __decorate([
        Watch('objects')
    ], TableProperties.prototype, "onObjectsChanged", null);
    TableProperties = __decorate([
        Component
    ], TableProperties);
    return TableProperties;
}(Vue));
export default TableProperties;
